/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiGenerateInteractionFromJSON, ApiGenerateInteractionToJSON, } from './ApiGenerateInteraction';
export function ApiGenerateInteractionsPayloadFromJSON(json) {
    return ApiGenerateInteractionsPayloadFromJSONTyped(json, false);
}
export function ApiGenerateInteractionsPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'interactions': !exists(json, 'interactions') ? undefined : (json['interactions'].map(ApiGenerateInteractionFromJSON)),
    };
}
export function ApiGenerateInteractionsPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'interactions': value.interactions === undefined ? undefined : (value.interactions.map(ApiGenerateInteractionToJSON)),
    };
}
